import React from "react";
import { PlanListContainer } from "../../../containers";

const PlanList = (props) => {
  return <PlanListContainer {...props} />;
};

export default PlanList;
